import React, { SVGProps } from "react";

export default function SupTransformAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 2L7.5752 5.3H9.60007V6.03106C9.60007 6.38921 9.43144 6.72647 9.14491 6.94137C7.8395 7.92043 8.25459 9.97594 9.83764 10.3717L9.96847 10.4044C10.898 10.6368 11.1417 11.8437 10.3752 12.4186C9.88725 12.7846 9.60007 13.359 9.60007 13.9689V14.7H7.5752L10.0001 18L12.4249 14.7H10.4001V13.9689C10.4001 13.6108 10.5687 13.2735 10.8552 13.0586C12.1606 12.0796 11.7455 10.0241 10.1625 9.6283L10.0317 9.59559C9.10213 9.36321 8.8584 8.15625 9.62491 7.58137C10.1129 7.21539 10.4001 6.64102 10.4001 6.03106V5.3H12.4249L10.0001 2ZM10.0001 3.35104L9.1558 4.5H10.8443L10.0001 3.35104ZM10.0001 16.649L10.8443 15.5H9.1558L10.0001 16.649Z"
        fill="currentColor"
      />
    </svg>
  );
}
